import { useEffect } from 'react'
import { clearTranslateHandler, setTranslateHandler } from 'src/@legacy/@optimal-page/hooks/useTranslateLink'

export const useRegisterTranslateHandler = (func) => {
  useEffect(() => {
    setTranslateHandler(func)
    return () => clearTranslateHandler()
  }, [])
}
